import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import moment from "moment";
import { MdOutlineMoreHoriz } from "react-icons/md";
import { useState } from "react";
import { setSelectedBlockedUser } from "../../features/blockedUsers/blockedUserSlice";
import { showModal } from "../../features/modal/modalSlice";


const Container = styled.div`
  width: 100%;
  margin-block: 5px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  .container {
    width: 100%;
    cursor: pointer;
    .content {
      width: 100% !important;
      padding: 15px 10px;
      border-radius: 10px;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      background-color: var(--color-light);
      color: ${({ theme }) => theme.mainTextColor} !important;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      .more{
        position: absolute;
        right: 10px;
        top: 12px;
        cursor: pointer;
        font-size: 20px;
      }
      .detail{
        position: absolute;
        right: 35px;
        top: 12px;
        z-index: 9;
        color: var(--color-main);
        background-color: white;
        padding: 5px 10px;
        border-radius: 5px;
        font-size: var(--font-size-sm);
          font-weight: var(--font-weight-md);
      }
      .row {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 15px;
        text-align: center;
        background-color: transparent;
        .col {
          
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          gap: 5px;
          .title{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-lg);
          }
          .text{
            font-size: var(--font-size-xs);
            font-weight: var(--font-weight-sm);
          }
          span {
            font-size: 20px;
          }
          
        }
      }
    }
  }

  @media (max-width: 650px){
    .row{
      grid-template-columns: 1fr 1fr !important;
    }
  }
  @media (max-width: 450px){
    .row{
      grid-template-columns: 1fr!important;
    }
  }
`;

const EngellenenAraclarContainerMobile = ({ data, isMoreActive, setIsMoreActive }) => {
  const { theme } = useSelector((state) => state.layout);
  const dispatch = useDispatch();


  return (
    <Container theme={theme}>
      <div className="container">
        <div className="content">
          <div className="row">
            <div className="col">
              <p className="title">Telefon</p>
              <p className="text">{data?.phoneNumber}</p>
            </div>
            <div className="col">
              <p className="title">Adı Soyadı</p>
              <p className="text">{data?.adSoyadUnvan}</p>
            </div>
            <div className="col">
              <p className="title">TC No</p>
              <p className="text">{data.tcNo}</p>
            </div>
            <div className="col">
              <p className="title">Plaka</p>
              <p className="text">{data.plate}</p>
            </div>
            <div className="col">
              <p className="title">Gerekçe-Açıklama-Not</p>
              <p className="text">{data.description}</p>
            </div>
            <div className="col">
              <p className="title">Listeye Kayıt Tarihi</p>
              <p className="text">{moment(data.createdAt).format('L') === "Invalid date" ? "-" : moment(data.createdAt).format('L')}</p>  
            </div>
          </div>

          <div onClick={()=> {dispatch(showModal("firmaKaraListeOption")); dispatch(setSelectedBlockedUser(data))}} className="more"><MdOutlineMoreHoriz/></div>
        </div>
      </div>
    </Container>
  );
};

export default EngellenenAraclarContainerMobile;
